import { IUseWalletStore } from '@/src/store/global/types';
import {
    FundHoldingDeleteTxParams,
    FundHoldingUpdateMinADATxParams
} from '../../Commons';
import { ProtocolEntity } from '../../Entities';
import { FundHoldingEntity } from '../../Entities/Fund.Holding.Entity';
import { SmartDBBtnHandlers } from '../index.exports.BtnHandlers.TxApiCalls';
import { FundHoldingTxApiCalls } from './Fund.Holding.FrontEnd.Tx.Api.Calls';

export class FundHoldingBtnHandlers extends SmartDBBtnHandlers {
    protected static _Entity = FundHoldingEntity;
    protected static _TxApiCalls = FundHoldingTxApiCalls;

    // #region class methods

    // #endregion class methods

    // #region front end Btn tx handlers

    public static async handleBtnUpdateMinADATx<T extends FundHoldingEntity>(
        setProcessingTxMessage: (value: string) => void,
        setProcessingTxHash: (value: string) => void,
        walletStore: IUseWalletStore,
        protocol: ProtocolEntity,
        txParams: FundHoldingUpdateMinADATxParams
    ): Promise<boolean> {
        console.log(1111)
        return this.handleBtnDoTransaction_V1(
            FundHoldingEntity,
            'Updating Min ADA...',
            'Update Min ADA Tx',
            setProcessingTxMessage,
            setProcessingTxHash,
            walletStore,
            txParams,
            FundHoldingTxApiCalls.callGenericTxApi.bind(this._TxApiCalls, FundHoldingEntity, 'update-min-ada')
        );
    }

    public static async handleBtnDeleteTx<T extends FundHoldingEntity>(
        setProcessingTxMessage: (value: string) => void,
        setProcessingTxHash: (value: string) => void,
        walletStore: IUseWalletStore,
        protocol: ProtocolEntity,
        txParams: FundHoldingDeleteTxParams
    ): Promise<boolean> {
        return this.handleBtnDoTransaction_V1(
            FundHoldingEntity,
            'Deleting Fund Holding...',
            'Delete Tx',
            setProcessingTxMessage,
            setProcessingTxHash,
            walletStore,
            txParams,
            FundHoldingTxApiCalls.callGenericTxApi.bind(this._TxApiCalls, FundHoldingEntity, 'delete')
        );
    }

    // #endregion front end Btn tx handlers
}
